var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhotoHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48.301 43.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.155,
    x2: 0.079,
    y2: 0.921,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee6e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7866f2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1150",
    "data-name": "Trac\\xE9 1150",
    d: "M22.677,3a7.245,7.245,0,0,0-7.029,5.488L14.6,12.66H9.245A7.245,7.245,0,0,0,2,19.905V39.226a7.245,7.245,0,0,0,7.245,7.245H43.056A7.245,7.245,0,0,0,50.3,39.226V19.905a7.245,7.245,0,0,0-7.245-7.245H37.7L36.654,8.488A7.245,7.245,0,0,0,29.624,3Zm10.041,9.66-.75-3A2.415,2.415,0,0,0,29.624,7.83H22.677a2.415,2.415,0,0,0-2.343,1.829l-.75,3ZM13.4,17.49H9.245A2.415,2.415,0,0,0,6.83,19.905V39.226a2.415,2.415,0,0,0,2.415,2.415H43.056a2.415,2.415,0,0,0,2.415-2.415V19.905a2.415,2.415,0,0,0-2.415-2.415H13.4ZM16.49,29.566a9.66,9.66,0,1,0,9.66-9.66A9.66,9.66,0,0,0,16.49,29.566Zm9.66,4.83a4.83,4.83,0,1,1,4.83-4.83A4.83,4.83,0,0,1,26.151,34.4ZM38.226,22.321a2.415,2.415,0,1,0,2.415-2.415A2.415,2.415,0,0,0,38.226,22.321Z",
    transform: "translate(-2 -3)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoHeader);
export default __webpack_public_path__ + "static/media/PhotoHeader.d6e0686709c487edac4b8baef60ee1cd.svg";
export { ForwardRef as ReactComponent };